import React from 'react'
import Collection from '../common/collection'

function CollectionÑ({ props }) {
  return (
    <Collection
      src={[
        'https://volverse-negro-daniel.s3.amazonaws.com/images/13.+fuego+refiner%C3%ADa8.jpg',
      ]}
      alt="Fuego de refinería"
    />
  )
}


export default CollectionÑ
